// src/components/ui/Loader.tsx
import React from "react";

export const FullScreenLoader: React.FC<{ label?: string }> = ({ label = "Loading…" }) => (
  <div className="flex items-center justify-center h-screen">
    <span className="text-lg">{label}</span>
  </div>
);

export const InlineLoader: React.FC<{ label?: string }> = ({ label = "Loading…" }) => (
  <div className="py-10 text-center text-gray-700">{label}</div>
);
